





















































































































































































































































import Vue from 'vue'

/**  Model **/
import { IEmpresaContactoModel, IEmpresaModel } from '@/store/types'

/**  Service **/
import EmpresaService from '@/services/EmpresaService'

import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'TarjetaContacto',
  computed: {
    ...mapGetters({ curUserObject: 'auth/curUserObject' })
  },

  data() {
    return {
      isMobile: false,
      empresa: {} as IEmpresaModel,
      contacto: {} as IEmpresaContactoModel,
      botones: [
        { img: 'phone.png', text: 'Llamar' },
        { img: 'email.png', text: 'Enviar correo' },
        { img: 'whatsapp.png', text: 'Enviar Whatsapp' },
        { img: 'download.png', text: 'Descargar Contacto' },
        { img: 'qr.png', text: 'Compartir mediante QR' }
      ],
      configuracionesSesion: {} as IEmpresaModel,
      apiKey: '',
      mapOptions: {
        center: {
          lat: 0,
          lng: 0
        },
        zoom: 4
      },
      dialog: false,
      center: { lat: 45.508, lng: -73.587 },
      markers: [] as any
    }
  },

  beforeDestroy() {
    if (typeof window === 'undefined') return

    window.removeEventListener('resize', this.onResize, { passive: true } as any)
  },

  async mounted() {
    this.onResize()

    window.addEventListener('resize', this.onResize, { passive: true })

    this.load()
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 600
    },

    async load() {
      this.$store.dispatch('app/showLoading')
      this.empresa = (await EmpresaService.findById({ Id: this.$route.params.idempresa } as any)) as any
      this.contacto = this.empresa.Contactos.find((f) => f.Id === this.$route.params.idcontacto) as any
      if (this.empresa.Latitud && this.empresa.Latitud != '') {
        this.center = { lat: parseFloat(this.empresa.Latitud), lng: parseFloat(this.empresa.Longitud) }
        this.markers.push({ position: this.center })
      }

      this.$store.dispatch('app/hideLoading')
    },

    vCard() {
      this.$store.dispatch('app/eCard', {
        empresa: this.empresa,
        contacto: this.contacto
      })
    },

    openWhatsapp(tel: any) {
      if (this.contacto.IndWhatsAppBusiness === true) {
        // window.open(tel, '_blank')
        window.open('https://api.whatsapp.com/send?phone=' + tel, '_blank')
      } else {
        window.open('https://api.whatsapp.com/send?phone=' + tel, '_blank')
      }
    },

    openLink(url: any) {
      if (url) window.open(url, '_blank')
    },

    openQR() {
      this.dialog = true
    }
  }
})
